<template>
  <div class="panel-card">
    <div class="card-header">
      <span><i class="el-icon-medal"></i> 会员</span>
      <span style="font-size:0.8rem;color:#ef4444;cursor:pointer;" @click="clearMember">清除</span>
    </div>
    <div class="member-row">
      <input
        type="text"
        class="search-input"
        style="padding:8px;"
        placeholder="手机/卡号"
        v-model="memberInput"
        @click="openKeyboard"
        readonly
      />
      <button class="btn-icon" @click="openKeyboard">
        <i class="el-icon-edit"></i>
      </button>
      <button class="btn-blue" @click="queryMember" style="padding:0 15px;">查询</button>
    </div>
    <div v-if="memberInfo" class="member-info-box active">
      <b>{{ memberInfo.name }} ({{ memberInfo.level }})</b><br>
      余额: ¥{{ memberInfo.balance }} | {{ memberInfo.discount }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberPanel',
  data() {
    return {
      memberInput: '',
      memberInfo: null
    }
  },
  methods: {
    openKeyboard() {
      this.$emit('open-keyboard')
    },
    queryMember() {
      if (this.memberInput.trim()) {
        this.$emit('query-member', this.memberInput.trim())
      }
    },
    clearMember() {
      this.memberInput = ''
      this.memberInfo = null
      this.$emit('clear-member')
    },
    setMemberInfo(info) {
      this.memberInfo = info
    },
    setMemberInput(value) {
      this.memberInput = value
    }
  }
}
</script>

<style scoped>
.panel-card {
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.card-header {
  font-weight: bold;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 8px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  color: #475569;
  font-size: 0.95rem;
}

.member-row {
  display: flex;
  gap: 8px;
}

.search-input {
  flex: 1;
  padding: 8px;
  font-size: 0.9rem;
  border: 2px solid #cbd5e1;
  border-radius: 6px;
  outline: none;
}

.btn-icon {
  width: 45px;
  background: #e2e8f0;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: #475569;
}

.btn-icon:hover {
  background: #cbd5e1;
}

.btn-blue {
  background: #2563eb;
  color: white;
  border: none;
  padding: 0 15px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-blue:hover {
  background: #1d4ed8;
}

.member-info-box {
  margin-top: 10px;
  background: #f0fdf4;
  padding: 10px;
  border: 1px dashed #10b981;
  border-radius: 4px;
  display: none;
  font-size: 0.9rem;
}

.member-info-box.active {
  display: block;
}
</style>

